import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './StickyFooter.less';

/**
 * When used in conjunction with StickyContainer and StickyBody, the StickyFooter will stay at the bottom of the page
 * if the StickyBody content height does not fill the page, as seen here:
 * https://css-tricks.com/couple-takes-sticky-footer/
 *
 * If fixToBottom is true, then the StickyFooter will be physically fixed the bottom of the viewport, regardless of
 * the content behind it. This can be used in conjunction with react-waypoint to create a footer that becomes sticky
 * when scrolled past a certain point.
 */
export class StickyFooter extends Component {
    static propTypes = {
        fixToBottom: PropTypes.bool.isRequired,
        children: PropTypes.node.isRequired,
        fadedBackground: PropTypes.bool
    };

    static defaultProps = {
        fadedBackground: true
    };

    static getDerivedStateFromProps(props, state) {
        const { fixToBottom } = props;
        const { lastFixToBottom } = state;

        if (fixToBottom !== lastFixToBottom) {
            // update state
            return {
                lastFixToBottom: fixToBottom,
                wrapperStyles: {
                    height: fixToBottom ? state.wrapperElt.offsetHeight : 'auto'
                }
            };
        }

        return null; // no change to state
    }

    constructor(props) {
        super(props);

        this.state = {
            wrapperElt: undefined,
            lastFixToBottom: this.props.fixToBottom,
            wrapperStyles: {}
        };
    }

    setWrapperRef = ref => {
        this.setState({
            wrapperElt: ref
        });
    };

    render() {
        const { children, fixToBottom, fadedBackground } = this.props;
        const { wrapperStyles } = this.state;
        const className = `StickyFooter${fixToBottom ? ' enabled' : ''}`;

        return (
            <div
                className={className}
                ref={this.setWrapperRef}
                style={wrapperStyles}
            >
                <div className="sticky-footer-container">
                    {fadedBackground && <div className="sticky-footer-fade" />}
                    <div className="sticky-footer-body">{children}</div>
                </div>
            </div>
        );
    }
}

export default StickyFooter;
